import React from "react";
import ReusableMapView from "../../../../components/ReusableMapView";

const SpaceMapView = ({ spaces, onSelectSpace }) => {
  // Transform spaces data to match ReusableMapView expected format
  const transformedSpaces =
    spaces?.map(space => ({
      ...space,
      // Ensure status matches expected values
      status: space.status === "PUBLISHED" ? "available" : space.status?.toLowerCase() || "available",
      // Add instanceCount if not present
      instanceCount: space.instanceCount || space.instances?.length || 1,
    })) || [];

  return (
    <div className="h-[500px] w-full">
      <ReusableMapView
        spaces={transformedSpaces}
        onSpaceClick={onSelectSpace}
        showLegend={true}
        showQuickView={true}
        className="h-full"
      />
    </div>
  );
};

export default SpaceMapView;
